export default {
  setFederations: (state, federations) => {
    state.federations = Object.keys(federations).map(key => { const el = federations[key]; el.federationId = parseInt(key); return el })
  },
  setFederationSsoGroups: (state, federationSsoGroups) => {
    state.federationSsoGroups = federationSsoGroups
  }
}
